<div *ngIf="showBanner" class="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-white/95 backdrop-blur-md text-gray-800 p-5 rounded-2xl border border-gray-200/80 shadow-2xl z-50 transition-all duration-300">
  <div class="flex flex-col gap-4">
    <div class="flex items-start gap-3">
      <div class="p-2 bg-teal-50 text-teal-600 rounded-xl">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <div>
        <h4 class="font-bold text-base text-gray-900">Cookie & Privacy Consent</h4>
        <p class="text-xs text-gray-500 mt-1 leading-relaxed">
          We use cookies to secure sessions and analyze platform traffic. Gating non-essential trackers (like Facebook Pixel) is done in compliance with the DPDP Act 2023. You can review your choices anytime.
        </p>
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 pt-2">
      <button 
        (click)="rejectAll()" 
        class="px-4 py-2 text-xs font-semibold text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-50 border border-gray-200 hover:border-gray-300 rounded-xl transition-all"
      >
        Reject Trackers
      </button>
      <button 
        (click)="acceptAll()" 
        class="px-4 py-2 text-xs font-semibold text-white bg-teal-500 hover:bg-teal-600 rounded-xl shadow-lg shadow-teal-500/10 transition-all"
      >
        Accept All
      </button>
    </div>
  </div>
</div>
